import * as commonScripts from '../common'
import 'whatwg-fetch'
import { listContainer } from './partials/fund-list/fund-list-container'
import { initSearchFund } from './partials/fund-list/fundSearch'
import utils from '../common/util'
const cmpFundList = {
  component: null,

  init: function (element) {
    const _ = this
    _.component = element
    utils.isLoading(true)
    setTimeout(function () {
      commonScripts.util.animationTranslate(this)
    }, 100)
    _.getFundData()
    initSearchFund(_.component)
    _.onPageLoad()
    utils.isLoading(false)
  },
  onPageLoad: function () {
    const selection = document.querySelector('.cmp-fund-list select').value
    const url = window.location.origin + window.location.pathname + '?' + 'assetClassId=' + selection
    window.history.replaceState({}, document.title, url)
  },
  getFundData: async function () {
    const id = document.getElementById('list-page-id').value
    let language = document.documentElement.lang
    if (language.length === 0) {
      language = 'en'
    }
    const selection = document.querySelector('.cmp-fund-list select').value
    // let listPageType = document.getElementById('fund-list-page-type').value

    let apiURL = ''
    if (window.location.hostname !== 'localhost') {
      apiURL = '/api/fundlist/'
    } 
    const url =
      apiURL +
      id +
      '?t=' +
      selection +
      '&s=&lang=' +
      language

    const response = await window.fetch(url)
    const data = await response.json()
    listContainer(data.JsonContent.funds, language)
  }
}

export default cmpFundList
